import { Activity } from "./ActivityCard";

  export const statusStyleMap: Record<string, any> = {
    'concluído': {
      borderColor: '#C5F6C5', color: '#1F791F', bgcolor: '#E8F5E9', fontWeight: 700
    },
    'concluido': {
      borderColor: '#C5F6C5', color: '#1F791F', bgcolor: '#E8F5E9', fontWeight: 700
    },
    'pendente': {
      borderColor: '#AA8208', color: '#AA8208', bgcolor: '#FFFBF0', fontWeight: 700
    },
    'vencido': {
      borderColor: '#FDCECE', color: '#920A0C', bgcolor: '#FFEFF0', fontWeight: 700
    },
    'approved': {
      borderColor: '#C5F6C5', color: '#1F791F', bgcolor: '#E8F5E9', fontWeight: 700
    },
    'pending supplier review': {
      borderColor: '#2196F3', color: '#2196F3', bgcolor: '#E3F2FD', fontWeight: 700
    },
    'pending response': {
      borderColor: '#AA8208', color: '#AA8208', bgcolor: '#FFFBF0', fontWeight: 700
    },
    'closed': {
      borderColor: '#FDCECE', color: '#920A0C', bgcolor: '#FFEFF0', fontWeight: 700
    },
    'default': {
      borderColor: '#BDBDBD', color: '#616161', bgcolor: '#F5F5F5', fontWeight: 700
    }
  };


  export function getLatestActivities(activities: Activity[]): Activity[] {
  const map: { [code: string]: Activity } = {};
  activities.forEach((act) => {
    if (!map[act.code] || new Date(act.dueDate) > new Date(map[act.code].dueDate)) {
      map[act.code] = act;
    }
  });
  return Object.values(map);
}
